<template>
  <div></div>
</template>

<script>
import { mapGetters } from "vuex";
import redirect from "@/mixins/redirect";

export default {
  name: "HomeView",
  mixins: [redirect],
  computed: {
    ...mapGetters("cognito", { isAuthenticated: "isAuthenticated" }),
  },
  watch: {
    isAuthenticated: function() {
      if (this.isAuthenticated) {
        this.redirect();
      }
    },
  },
  created() {
    this.redirect();
  },
  methods: {
    async redirect() {
      if (this.$route.path === "/" && this.isAuthenticated) {
        await this.redirectToHome();
      }
    },
  },
};
</script>
